import { gql } from "@apollo/client";
import { LibraryItemDetailPage_LibraryItemFragment } from "../LibraryItemDetailPageContainer.generated";
import useModuleBuilderContentPermission from "@src/features/libraryItem/module/hooks/useModuleBuilderContentPermission";
import { LibraryItemContentPermissionsFragment } from "./useLibraryItemPermissions.generated";
import { useContentPermissionsQuery } from "./useContentPermissions.generated";

const useLibraryItemPermissions = (
  libraryItem?: LibraryItemDetailPage_LibraryItemFragment | null,
): LibraryItemContentPermissionsFragment | undefined => {
  // Version-aware but not tab-aware: this shapes which tabs exist, and the
  // read-only Content tab must still be able to offer the way into Build.
  const moduleBuilderVersionPermissions = useModuleBuilderContentPermission({
    maskViewingTab: false,
  });
  const { data } = useContentPermissionsQuery({
    variables: {
      courseId: libraryItem?.course?.id,
      moduleId: libraryItem?.module?.id,
      skillId: libraryItem?.skill?.id,
      trainingResourceId: libraryItem?.trainingResource?.id,
    },
    skip:
      !libraryItem?.course?.id &&
      !libraryItem?.module?.id &&
      !libraryItem?.skill?.id &&
      !libraryItem?.trainingResource?.id,
    fetchPolicy: "cache-first",
  });
  return (
    // If in the module detail page, module permissions always take priority
    moduleBuilderVersionPermissions || data?.ContentPermissions || undefined
  );
};

gql`
  query LibraryItemContentPermissions(
    $courseId: Int
    $moduleId: Int
    $skillId: Int
    $trainingResourceId: UUID
  ) {
    ContentPermissions: AdminContentPermissions(
      courseId: $courseId
      moduleId: $moduleId
      skillId: $skillId
      trainingResourceId: $trainingResourceId
    ) {
      ...ContentPermissions
    }
  }

  fragment LibraryItemContentPermissions on ContentPermissions {
    hasEditContentPermission
    hasPublishPermission
    hasCommentPermission
    hasShareWithIndividualsPermission
    hasEditAdminAndManagerSharingPermission
  }
`;

export default useLibraryItemPermissions;
